export default __webpack_public_path__ + "static/media/mail-disabled.06c7a364.svg";